// extracted by mini-css-extract-plugin
module.exports = {"List":"List_List__Imkue","horizontal":"List_horizontal__3HZZO"};